module.exports = {
    Extra_Reward : "ExchangeEvent.Extra_Reward"
}